(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('internetUsageHomeCtrl', ['$scope', '$rootScope', '$state', '$http', 'uteEndpoint', '$stateParams', 'uteLocale','commonService', function ($scope, $rootScope, $state, $http, uteEndpoint, $stateParams, uteLocale, commonService) {

      var self = this;

      $scope.go = function (state) {
        $state.go(state);
      };

      $scope.tabData = [
        {
          heading: 'global.label.internetUsageDailyHeading',
          subheading: 'global.label.internetUsageDailySubheading',
          route: 'myAccount.internetUsage.daily'
        },
        {
          heading: 'global.label.internetUsageMonthlyHeading',
          subheading: 'global.label.internetUsageMonthlySubheading',
          route: 'myAccount.internetUsage.monthly'
        },
        {
          heading: 'global.label.internetUsageNotificationHeading',
          subheading: 'global.label.internetUsageNotificationSubheading',
          route: 'myAccount.internetUsage.notification'
        }
      ];

      $scope.formatDate = function (string) {
        var date;
        if (string !== undefined) {
          if (uteLocale.language === 'fr') {
            date = moment(string).format('D MMM YYYY');
          } else {
            date = moment(string).format('MMM D, YYYY');
          }
          return date;
        } else if (string === 'test') {
          return 'success';
        }
      };

      self.init = function () {
        // DC-188: code cleanup, following moved to route resolve

        // if ($stateParams.accountNumber && $stateParams.subscriberNo) {
        //   $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
        //   $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
        // } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) || (!$stateParams.subscriberNo && !$rootScope.userInfo.selectedSubscriberNo)) {
        //   $state.go('myAccount.overview');
        // } else {
        //   if (!$stateParams.accountNumber) {
        //     $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
        //   }
        //   if (!$stateParams.subscriberNo) {
        //     $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo;
        //   }
        // }

        $scope.accountNumber = $stateParams.accountNumber || $rootScope.userInfo.selectedAccountNumber;
        $scope.subscriberNo = $stateParams.subscriberNo || $rootScope.userInfo.selectedSubscriberNo;
      };

      self.init();

    }]);

})();
